<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              알림 등록
            </div>
          </section>
          <!-- 메일 활성(Class) : mailActive / SMS 활성(Class) : smsActive -->
          <section class="section02" :class="alarmMethod === 'sms' ? 'smsActive' : alarmMethod === 'email' ? 'mailActive' : ''">
            <div class="object01"></div>
            <div class="object02"></div>
            <div class="object03">
              발송일시
            </div>
            <div class="object04">
              <div class="formCalendar">
                <div class="formCalendarList">
                  <date-picker
                    v-model="dateTime"
                    type="datetime"
                    format="YYYY-MM-DD HH:mm"
                    :clearable="false"
                    :editable="false"
                    placeholder="발송일시를 선택하세요."
                    :disabled-date="disableBeforeToday"
                    :minute-step="5"
                    :open.sync="isDatePickerOpen"
                    @close="updateValues"
                    @change="handleChange"
                  />
                </div>
              </div>
            </div>
            <div class="object05"></div>
            <div class="object06"></div>
            <div class="object07">
              대상
            </div>
            <div class="object08">
              <div class="formSelect" ref="select01">
                <div class="formSelectList" @click="openSelect01">
                  <input type="text" v-model="select01Value" placeholder="대상을 선택하세요." readonly />
                </div>
                <div class="formSelectPopup typeSearch typeMulti select01">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" placeholder="대상을 선택하세요." v-model="searchValue" v-on:keyup="changeSearchValue" />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" @click="selectAll" :checked="allSelected"/>
                                  <i></i>
                                  <span>전체선택</span>
                                </label>
                              </li>
                              <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                                <label>
                                  <input type="radio"/>
                                  <input type="checkbox" v-model="selectedClubList" name="selectedClubList" :value="clubInfo.ccode"/>
                                  <i></i>
                                  <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel" @click="cancelSelect01">
                                취소
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm" @click="confirmSelect01">
                                확인
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="object09"></div>
            <div class="object10"></div>
            <div class="object11">
              알림 종류
            </div>
            <div class="object12">
              <div class="formSelect" ref="select02" @click="openSelect02">
                <div class="formSelectList">
                  <input type="text" :value="findAlarmMethodName(alarmMethod)" placeholder="알림 종류를 선택하세요." readonly />
                </div>
                <div class="formSelectPopup select02">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" placeholder="알림 종류를 선택하세요." />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li v-for="alarmMethodInfo in alarmMethodList" :key="alarmMethodInfo.code">
                                <label>
                                  <input type="radio" v-model="alarmMethod" :value="alarmMethodInfo.code" @change="resetContents"/>
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>{{ alarmMethodInfo.name }}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                취소
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                확인
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="object1301">
              <div class="object13"></div>
              <div class="object14"></div>
              <div class="object15">
                SMS 메시지 입력
              </div>
              <div class="object16">
                <textarea placeholder="SMS 메시지를 입력하세요." v-model="content" maxlength="40" ></textarea>
              </div>
              <div class="object17">
                <strong>{{ content.length }}</strong>/40
              </div>
            </div>
            <div class="object1302">
              <div class="object13"></div>
              <div class="object14"></div>
              <div class="object15">
                제목
              </div>
              <div class="object16">
                <input type="text" placeholder="제목을 입력하세요." v-model="emailTitle" />
              </div>
              <div class="object17"></div>
              <div class="object18">
                <textarea placeholder="내용을 입력하세요." v-model="content"></textarea>
              </div>
              <div class="object19"></div>
            </div>
          </section>
          <section class="section03">
            <div class="object01"></div>
            <div class="object02">
              첨부
            </div>
            <!-- 첨부파일 있을때(Class) : boxActive -->
            <div class="object03" :class="emailAttachments.length ? 'boxActive' : ''">
              <div class="attachment">
                <button class="attachment">
                  파일첨부
                </button>
                <div class="box">
                  <ul class="attachmentList">
                    <li v-for="attachment in emailAttachments" :key="attachment.name+attachment.size">
                      <div class="delete" @click="removeAttachment(attachment)">
                        삭제
                      </div>
                      <div class="file">
                        {{ attachment.name }}
                      </div>
                    </li>
                  </ul>
                </div>
                <input @change="handleAttachments" type="file" multiple="multiple" name="filename[]"/>
              </div>
            </div>
          </section>
          <section class="section04">
            <div class="object01">
              <button class="cancel" @click="moveMenu('SE201')">
                취소
              </button>
            </div>
            <div class="object02">
              <!-- 비활성(Attribute) : disabled -->
              <button class="registration" :disabled="!passValidation" @click="postData">
                등록
              </button>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="alert typeConfirm">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertMessage">
                  </div>
                  <div class="footer">
                    <button class="cancel">
                      취소
                    </button>
                    <button class="confirm" @click="confirmAlert">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup typeMulti typeSearch select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="대상을 선택하세요." v-model="searchValue" v-on:keyup="changeSearchValue" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" @click="selectAll" :checked="allSelected"/>
                        <i></i>
                        <span>전체선택</span>
                      </label>
                    </li>
                    <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                      <label>
                        <input type="radio"/>
                        <input type="checkbox" v-model="selectedClubList" name="selectedClubList" :value="clubInfo.ccode"/>
                        <i></i>
                        <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel" @click="cancelSelect01">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm" @click="confirmSelect01">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02" @click="openSelect02">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="알림 종류를 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="alarmMethodInfo in alarmMethodList" :key="alarmMethodInfo.code">
                      <label>
                        <input type="radio" v-model="alarmMethod" :value="alarmMethodInfo.code"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ alarmMethodInfo.name }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {clubInfoService, settingService, userService} from '../../router'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'SE203',
  data () {
    return {
      dateTime: '',
      isDatePickerOpen: false,
      userInfo: {},
      selectedClubList: [],
      currentClubList: [],
      alarmMethod: '',
      alarmMethodList: [
        {name: 'Email', code: 'email'},
        {name: 'SMS', code: 'sms'}
      ],
      emailTitle: '',
      content: '',
      emailAttachments: []
    }
  },
  created: function () {
    Promise.all([userService.getAll(), clubInfoService.getClubInfoList('active')]).then(response => {
      this.userInfo = response[0].data
      this.clubInfoList = response[1].data.clubInfoList
      this.selectClubInfoList = response[1].data.clubInfoList
    }).catch(error => {
      console.log('getClubInfoListByStatusActive.err.===>', error)
    })
  },
  mounted: function () {
    this.setData()
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout,
    DatePicker
  },
  methods: {
    setData: function () {
    },
    postData: function () {
      if (!this.passValidation) return false
      if (!this.updateValues()) return false
      settingService.insertAlarm({
        target_all_yn: this.allSelected ? 1 : 0,
        status: 'ready',
        alarm_type: '',
        alarm_method: this.alarmMethod,
        alarm_send_datetime: this.dateTime,
        email_title: this.emailTitle,
        content: this.content,
        read_yn: 0,
        target_id: this.selectedClubList.join(','),
        landing_page: ''
      }).then(response => {
        if (response.statusCode === 200) {
          this.openAlert('알림 발송이 예약 되었습니다.', '/SE202?alarm_id=' + response.data.alarmId)
        } else if (response.statusCode === 202) {
          this.openAlert('알림 대상에 수신인이<br>존재하지 않습니다.<br>다시 시도해주세요.', null)
        } else if (response.statusCode !== 200) {
          this.openAlert('알림 등록에 실패했습니다.<br>다시 시도해주세요.', null)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    updateValues: function () {
      if (!this.dateTime || this.dateTime > new Date()) return true
      this.openAlert('지금 보다 미래의 날짜 및 시간만<br>입력 가능합니다.')
      this.dateTime = ''
      return false
    },
    disableBeforeToday: function (date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date < today
    },
    openSelect01: function () {
      if (document.querySelector('body.type-content.select01Active') !== null) {
        this.cancelSelect01()
      } else {
        this.closeSelectAll()
        document.querySelector('body.type-content').classList.add(`select01Active`)
        document.querySelector('body.type-content').classList.add('multiSelect')
      }
    },
    cancelSelect01: function () {
      this.selectedClubList = this.currentClubList
      this.closeSelectAll()
    },
    confirmSelect01: function () {
      this.currentClubList = this.selectedClubList
      this.closeSelectAll()
    },
    findAlarmMethodName: function (method) {
      if (this.alarmMethodList.find(it => it.code === method) !== undefined) {
        return this.alarmMethodList.find(it => it.code === method).name
      } else {
        return ''
      }
    },
    selectAll: function () {
      if (this.allSelected) {
        this.selectedClubList = []
      } else {
        this.selectedClubList = this.clubInfoList.map(it => it.ccode)
      }
    },
    resetContents: function () {
      this.emailTitle = ''
      this.content = ''
      this.emailAttachments = []
    },
    handleAttachments: function (e) {
      if (![...e.target.files].length) return
      this.emailAttachments = [...e.target.files]
    },
    removeAttachment: function (attachment) {
      this.emailAttachments = this.emailAttachments.filter(atc => atc !== attachment)
    },
    handleChange: function (value, type) {
      if (type !== 'minute') return
      this.updateValues()
      this.isDatePickerOpen = false
    }
  },
  computed: {
    select01Value: function () {
      if (!this.selectedClubList.length) return ''
      if (this.selectedClubList.length === this.clubInfoList.length) return '전체'
      return `골프클럽(${this.selectedClubList.length})`
    },
    allSelected: function () {
      return this.selectedClubList.length === this.clubInfoList.length
    },
    passValidation: function () {
      if (!this.dateTime) return false
      if (!this.selectedClubList.length) return false
      if (!this.alarmMethod) return false
      if (!this.content) return false
      if (this.alarmMethod === 'email' && !this.emailTitle) return false
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/setting/SE203.vue